import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-certificate-form',
  templateUrl: './training-certificate-form.component.html',
  styleUrls: ['./training-certificate-form.component.css']
})
export class TrainingCertificateFormComponent implements OnInit {
 
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/training-certificate/training-certificate-form/training-certificate-form.component.ts